import _isNumber from "lodash/isNumber";
import _isNil from "lodash/isNil";
import _isNaN from "lodash/isNaN";
import i18n from '@signavio/i18n';
export default function money({
  value,
  required
}, skipRequired) {
  if (!value) {
    return [];
  }
  if (!skipRequired && required && (!_isNumber(value.amount) || _isNaN(value.amount))) {
    return [i18n('Please enter a valid amount.')];
  }
  if (!_isNil(value.amount) && (!_isNumber(value.amount) || _isNaN(value.amount))) {
    return [i18n('Please enter a valid amount.')];
  }
  if (!value.currency) {
    return [i18n('Please enter a valid currency.')];
  }
  return [];
}